<dashboard-loader *ngIf="loadingInterventions$ | async" [title]="'Loading interventions page details...'">
</dashboard-loader>
<div *ngIf="interventionsLoaded$ | async">
  <div class="dashboard-intervention" fxLayout="row" fxLayoutAlign="space-around start">
    <div
      class="dashboard-intervention__left"
      fxLayout="column"
      fxLayoutAlign="space-around start"
      fxFlex="40"
      *ngIf="!isOverview"
    >
      <h1 class="dashboard-intervention__left-title">Interventions</h1>
      <div
        *ngIf="allInterventions && allInterventions.length !== 0"
        fxLayout.gt-lg="row"
        fxLayout.lt-xl="column"
        fxFill
      >
        <div class="dashboard-intervention__left-button">
          <button
            mat-raised-button
            color="accent"
            (click)="onNewIntervention()"
            [disabled]="!isEdit"
            *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
          >
            {{ 'New intervention' | uppercase }}
          </button>
        </div>
        <div class="dashboard-intervention__left-filter" fxLayoutGap="20px">
          <mat-form-field>
            <button matSuffix mat-icon-button aria-label="Search">
              <mat-icon>search</mat-icon>
            </button>
            <input
              [(ngModel)]="searchInterventions"
              (ngModelChange)="filterInterventions()"
              matInput
              placeholder="Search by title"
            />
          </mat-form-field>
          <mat-form-field style="width: 130px">
            <mat-label>Sort by</mat-label>
            <mat-select>
              <mat-option
                #sortOption
                *ngFor="let option of sortOptions"
                [value]="option.value"
                (click)="sort(sortOption.value)"
              >
                {{ option.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <mat-card *ngIf="allInterventions && allInterventions.length === 0">
        There are no interventions that you can view or edit
      </mat-card>
      <div fxFill>
        <virtual-scroller #scroll class="dashboard-intervention__left-scroll" [items]="sortedInterventions">
          <mat-card
            *ngFor="let intervention of scroll.viewPortItems"
            class="dashboard-intervention__left-scroll-interventions-card"
          >
            <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
              <mat-card-title class="dashboard-intervention__left-scroll-interventions-card-title">
                {{
                  intervention?.name.length > interventionTitleLimitation
                    ? (intervention?.name | slice: 0:interventionTitleLimitation) + '...'
                    : intervention?.name
                }}
              </mat-card-title>
              <p class="dashboard-intervention__left-scroll-interventions-card-status">
                {{ (intervention?.isDefault ? 'Default' : '') | uppercase }}
              </p>
            </mat-card-header>
            <mat-card-content class="dashboard-intervention__left-scroll-interventions-card-content">
              <div class="dashboard-intervention__left-scroll-interventions-card-text">
                <div>
                  {{
                    intervention?.description.length > interventionDescriptionLimitation
                      ? (intervention?.description | slice: 0:interventionDescriptionLimitation) + '...'
                      : intervention?.description
                  }}
                </div>
                <br />
                <span
                  *ngIf="selectedIntervention?.id !== intervention.id"
                  class="dashboard-intervention__left-scroll-interventions-card-content-text-badge"
                >
                  {{ intervention?.modulePivots?.length ? intervention.modulePivots.length : 0 }}
                  modules
                </span>
                <span
                  *ngIf="selectedIntervention?.id === intervention.id"
                  class="dashboard-intervention__left-scroll-interventions-card-content-text-badge"
                >
                  {{ selectedInterventionContentItems.length }}
                  modules
                </span>
                <mat-icon
                  *ngIf="intervention?.startFromPhone"
                  inline="true"
                  class="dashboard-intervention__left-scroll-interventions-card-content-icon"
                >
                  phone_iphone
                </mat-icon>
                <span
                  *ngIf="!!intervention?.codeExpired"
                  class="dashboard-intervention__left-scroll-interventions-card-content-text-warning-badge"
                >
                  finished
                </span>
              </div>
            </mat-card-content>
            <mat-divider [inset]="true"></mat-divider>
            <mat-card-actions
              class="dashboard-intervention__left-scroll-interventions-card-actions"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <ng-container
                *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
              >
                <button mat-button color="warn" (click)="openDeleteDialog(intervention)">
                  {{ 'Delete' | uppercase }}
                </button>
                <button
                  mat-button
                  (click)="duplicateIntervention(intervention)"
                  [disabled]="!!intervention?.codeExpired"
                >
                  {{ 'Duplicate' | uppercase }}
                </button>
              </ng-container>
              <button mat-button (click)="openInterventionDetails(intervention)">
                {{ 'Open' | uppercase }}
              </button>
            </mat-card-actions>
          </mat-card>
        </virtual-scroller>
      </div>
    </div>
    <div class="dashboard-intervention__center" *ngIf="!isOverview">
      <div class="dashboard-intervention__center-line"></div>
    </div>
    <div
      class="dashboard-intervention__right"
      fxLayout="column"
      fxLayoutAlign="space-around stretch"
      fxLayoutGap="40px"
      fxFlex="45"
    >
      <div *ngIf="isEdit">
        <button mat-raised-button color="accent" *ngIf="isOverview" (click)="backToOverview()">
          {{ 'Back to Intervention list' | uppercase }}
        </button>
        <mat-tab-group
          mat-stretch-tabs
          dynamicHeight
          #tabs
          class="dashboard-intervention__right-group"
          fxLayout="column"
          fxLayoutAlign="center"
          fxFill
          [selectedIndex]="startModuleSet ? 1 : 0"
          (selectedTabChange)="tabChanged($event)"
        >
          <mat-tab label="GENERAL">
            <dashboard-intervention-form [isEdit]="isEdit" fxFill></dashboard-intervention-form>
          </mat-tab>
          <mat-tab *ngIf="selectedStudy?.type === StudyType.TIIM" label="MODULES">
            <dashboard-intervention-modules></dashboard-intervention-modules>
          </mat-tab>
          <mat-tab *ngIf="selectedStudy?.type === StudyType.CC" label="CONTENT">
            <dashboard-intervention-content [isEdit]="isEdit"></dashboard-intervention-content>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div *ngIf="!isEdit && !isOverview">
        <h1 class="dashboard-intervention__right-title">
          {{
            privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)
              ? 'Create new intervention'
              : ''
          }}
        </h1>
        <dashboard-intervention-form fxFill></dashboard-intervention-form>
      </div>
    </div>
    <div class="dashboard-intervention__center" *ngIf="isOverview">
      <div class="dashboard-intervention__center-line"></div>
    </div>
    <div
      class="dashboard-intervention__right"
      fxLayout="column"
      fxLayoutAlign="space-around start"
      fxFlex="50"
      *ngIf="isOverview"
    >
      <dashboard-esm-calender
        [mode]="'overview'"
        [esmTriggerRules]="esmRules"
        [esmModuleNames]="esmModuleNames"
        *ngIf="esmRules.length > 0"
      ></dashboard-esm-calender>
      <div *ngIf="this.loading" class="loading-rules">
        <mat-spinner></mat-spinner>
        <p>Loading timing rules...</p>
      </div>
    </div>
  </div>
</div>
